import React from 'react';

import { ICitySatellite } from '@r1-frontend/api-domru/api-content/v1/geography/get-cities-satellites';

import { Moscow, StPetersburg } from '@r1-frontend/ui-react/components/svg/main';

import * as ST from './styled';

const CityIcon = ({ cityIndex }: { cityIndex: number }): JSX.Element => {
    switch (cityIndex) {
        case 0:
            return <Moscow size={24}/>;
        case 1:
            return <StPetersburg size={24}/>;
        default:
            return <></>;
    }
};

interface IProps {
    topCities: ICitySatellite[],
    onCitySelect: (city: ICitySatellite) => void,
}

const TopCities = ({ topCities, onCitySelect }: IProps): JSX.Element => {
    return (
        <ST.TopCitiesWrap>
            {topCities.map((topCity, index) => (
                <ST.TopCityElement
                    key={topCity.provider_id}
                    onClick={() => onCitySelect(topCity)}
                    data-test='top-city'
                >
                    <CityIcon cityIndex={index}/>
                    {topCity.name}
                </ST.TopCityElement>
            ))}
        </ST.TopCitiesWrap>
    );
};

export default TopCities;
